(function ($) {
	$(window).on("elementor/frontend/init", function () {
		elementorFrontend.hooks.addAction("frontend/element_ready/documentations.default", () => {
			var getUrlParameter = function getUrlParameter(sParam) {
				var sPageURL = window.location.search.substring(1),
					sURLVariables = sPageURL.split("&"),
					sParameterName,
					i;

				for (i = 0; i < sURLVariables.length; i++) {
					sParameterName = sURLVariables[i].split("=");

					if (sParameterName[0] === sParam) {
						return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
					}
				}
				return false;
			};

			$(".reset").click(function () {
				$('.filtre[data-filter="all"').click();
			});

			$(".archives-documentation .filtres").change(function () {
				let classe = $(this).val();
				$(".grid-post .post").each(function () {
					if ($(this).hasClass(classe)) {
						$(this).show();
					} else {
						$(this).hide();
					}
				});
			});

			$(".archives-documentation #inline_post").keyup(function (event) {
				if (event.target.value.length > 2) {
					$(".grid-post .post").each(function () {
						if (
							$(this)
								.find("h2")[0]
								.innerText.toLowerCase()
								.normalize("NFD")
								.replace(/[\u0300-\u036f]/g, "")
								.includes(
									event.target.value
										.toLowerCase()
										.normalize("NFD")
										.replace(/[\u0300-\u036f]/g, "")
								)
						) {
							$(this).removeClass("hidden");
						} else {
							$(this).addClass("hidden");
						}
					});
				} else {
					$(".grid-post .post").each(function () {
						$(this).removeClass("hidden");
					});
				}
			});

			var parameters = getUrlParameter("filtres");
			if (parameters.length) {
				$(".filtre[data-filter=" + parameters).trigger("click");
			}
		});
	});
})(jQuery);

window.addEventListener("DOMContentLoaded", () => {});
